"use client";

const rangeOptions = ["1M", "3M", "1Y", "ALL"];

export default function AssetsHistory({ range, onRangeChange }) {

  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">Assets History</span>
        <div className="chart-filters">
          {rangeOptions.map((option) => (
            <button
              key={option}
              className={`chart-filter-btn ${option === range ? "active" : ""}`}
              type="button"
              onClick={() => onRangeChange(option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>
      <div className="chart-container">
        <canvas id="assetsChart"></canvas>
      </div>
      <div className="chart-legend">
        <div className="legend-item">
          <span className="legend-dot" style={{ background: "#1a2b5f" }}></span>
          Net Exposure Value
        </div>
        <div className="legend-item">
          <span className="legend-dot" style={{ background: "#5BA4E6" }}></span>
          Total Assets Value
        </div>
      </div>
    </div>
  );
}
